import { Component, OnInit } from '@angular/core';
import { SharedserviceService} from '../sharedservice.service';

import {
  trigger,
  state,
  style,
  animate,
  transition,
  // ...
} from '@angular/animations';

@Component({
  selector: 'app-smart-mate-header',
  templateUrl: './smart-mate-header.component.html',
  styleUrls: ['./smart-mate-header.component.less'],
  animations: [ trigger('fade', [
    transition(':enter', [
      style({ opacity: 0 ,position: 'relative', top: '50%'}),
      animate('0.8s', style({ opacity: 1, position: 'relative',top: 0  })),
    ]),
    ])
  ]
})
export class SmartMateHeaderComponent implements OnInit {
  
  accountType: any;

  constructor(private SharedserviceService: SharedserviceService) { }

  ngOnInit(): void {
    this.SharedserviceService.castUserType.subscribe(userType => this.accountType = userType);
  }

}
